// source: v1/teams_users_types.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.V1.CloudTelephonyCapability', null, global);
goog.exportSymbol('proto.V1.ServicePlan', null, global);
goog.exportSymbol('proto.V1.TeamsUser', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.TeamsUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.V1.TeamsUser.repeatedFields_, null);
};
goog.inherits(proto.V1.TeamsUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.TeamsUser.displayName = 'proto.V1.TeamsUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.CloudTelephonyCapability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.V1.CloudTelephonyCapability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.CloudTelephonyCapability.displayName = 'proto.V1.CloudTelephonyCapability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.V1.ServicePlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.V1.ServicePlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.V1.ServicePlan.displayName = 'proto.V1.ServicePlan';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.V1.TeamsUser.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.TeamsUser.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.TeamsUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.TeamsUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.TeamsUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: (f = msg.getDisplayName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sipAddress: (f = msg.getSipAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    phoneNumber: (f = msg.getPhoneNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    enterpriseVoiceEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    isChargeable: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    onlineVoiceRoutingPolicy: (f = msg.getOnlineVoiceRoutingPolicy()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    endpointType: (f = msg.getEndpointType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    servicePlansList: jspb.Message.toObjectList(msg.getServicePlansList(),
    proto.V1.ServicePlan.toObject, includeInstance),
    cloudTelephonyCapability: (f = msg.getCloudTelephonyCapability()) && proto.V1.CloudTelephonyCapability.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.TeamsUser}
 */
proto.V1.TeamsUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.TeamsUser;
  return proto.V1.TeamsUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.TeamsUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.TeamsUser}
 */
proto.V1.TeamsUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDisplayName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSipAddress(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhoneNumber(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnterpriseVoiceEnabled(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsChargeable(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOnlineVoiceRoutingPolicy(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEndpointType(value);
      break;
    case 9:
      var value = new proto.V1.ServicePlan;
      reader.readMessage(value,proto.V1.ServicePlan.deserializeBinaryFromReader);
      msg.addServicePlans(value);
      break;
    case 10:
      var value = new proto.V1.CloudTelephonyCapability;
      reader.readMessage(value,proto.V1.CloudTelephonyCapability.deserializeBinaryFromReader);
      msg.setCloudTelephonyCapability(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.TeamsUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.TeamsUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.TeamsUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.TeamsUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSipAddress();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhoneNumber();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEnterpriseVoiceEnabled();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIsChargeable();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getOnlineVoiceRoutingPolicy();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEndpointType();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getServicePlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.V1.ServicePlan.serializeBinaryToWriter
    );
  }
  f = message.getCloudTelephonyCapability();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.V1.CloudTelephonyCapability.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.V1.TeamsUser.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue display_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.TeamsUser.prototype.getDisplayName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.TeamsUser} returns this
*/
proto.V1.TeamsUser.prototype.setDisplayName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.clearDisplayName = function() {
  return this.setDisplayName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.TeamsUser.prototype.hasDisplayName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue sip_address = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.TeamsUser.prototype.getSipAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.TeamsUser} returns this
*/
proto.V1.TeamsUser.prototype.setSipAddress = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.clearSipAddress = function() {
  return this.setSipAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.TeamsUser.prototype.hasSipAddress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue phone_number = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.TeamsUser.prototype.getPhoneNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.TeamsUser} returns this
*/
proto.V1.TeamsUser.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.clearPhoneNumber = function() {
  return this.setPhoneNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.TeamsUser.prototype.hasPhoneNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool enterprise_voice_enabled = 5;
 * @return {boolean}
 */
proto.V1.TeamsUser.prototype.getEnterpriseVoiceEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.setEnterpriseVoiceEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool is_chargeable = 6;
 * @return {boolean}
 */
proto.V1.TeamsUser.prototype.getIsChargeable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.setIsChargeable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional google.protobuf.StringValue online_voice_routing_policy = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.TeamsUser.prototype.getOnlineVoiceRoutingPolicy = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.TeamsUser} returns this
*/
proto.V1.TeamsUser.prototype.setOnlineVoiceRoutingPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.clearOnlineVoiceRoutingPolicy = function() {
  return this.setOnlineVoiceRoutingPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.TeamsUser.prototype.hasOnlineVoiceRoutingPolicy = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue endpoint_type = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.TeamsUser.prototype.getEndpointType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.TeamsUser} returns this
*/
proto.V1.TeamsUser.prototype.setEndpointType = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.clearEndpointType = function() {
  return this.setEndpointType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.TeamsUser.prototype.hasEndpointType = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated ServicePlan service_plans = 9;
 * @return {!Array<!proto.V1.ServicePlan>}
 */
proto.V1.TeamsUser.prototype.getServicePlansList = function() {
  return /** @type{!Array<!proto.V1.ServicePlan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.V1.ServicePlan, 9));
};


/**
 * @param {!Array<!proto.V1.ServicePlan>} value
 * @return {!proto.V1.TeamsUser} returns this
*/
proto.V1.TeamsUser.prototype.setServicePlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.V1.ServicePlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.V1.ServicePlan}
 */
proto.V1.TeamsUser.prototype.addServicePlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.V1.ServicePlan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.clearServicePlansList = function() {
  return this.setServicePlansList([]);
};


/**
 * optional CloudTelephonyCapability cloud_telephony_capability = 10;
 * @return {?proto.V1.CloudTelephonyCapability}
 */
proto.V1.TeamsUser.prototype.getCloudTelephonyCapability = function() {
  return /** @type{?proto.V1.CloudTelephonyCapability} */ (
    jspb.Message.getWrapperField(this, proto.V1.CloudTelephonyCapability, 10));
};


/**
 * @param {?proto.V1.CloudTelephonyCapability|undefined} value
 * @return {!proto.V1.TeamsUser} returns this
*/
proto.V1.TeamsUser.prototype.setCloudTelephonyCapability = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.TeamsUser} returns this
 */
proto.V1.TeamsUser.prototype.clearCloudTelephonyCapability = function() {
  return this.setCloudTelephonyCapability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.TeamsUser.prototype.hasCloudTelephonyCapability = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.CloudTelephonyCapability.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.CloudTelephonyCapability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.CloudTelephonyCapability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.CloudTelephonyCapability.toObject = function(includeInstance, msg) {
  var f, obj = {
    isCapable: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    reasonCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.CloudTelephonyCapability}
 */
proto.V1.CloudTelephonyCapability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.CloudTelephonyCapability;
  return proto.V1.CloudTelephonyCapability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.CloudTelephonyCapability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.CloudTelephonyCapability}
 */
proto.V1.CloudTelephonyCapability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCapable(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasonCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.CloudTelephonyCapability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.CloudTelephonyCapability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.CloudTelephonyCapability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.CloudTelephonyCapability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsCapable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getReasonCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool is_capable = 1;
 * @return {boolean}
 */
proto.V1.CloudTelephonyCapability.prototype.getIsCapable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.V1.CloudTelephonyCapability} returns this
 */
proto.V1.CloudTelephonyCapability.prototype.setIsCapable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string reason_code = 2;
 * @return {string}
 */
proto.V1.CloudTelephonyCapability.prototype.getReasonCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.CloudTelephonyCapability} returns this
 */
proto.V1.CloudTelephonyCapability.prototype.setReasonCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.V1.ServicePlan.prototype.toObject = function(opt_includeInstance) {
  return proto.V1.ServicePlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.V1.ServicePlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.ServicePlan.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    servicePlanType: (f = msg.getServicePlanType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    allowsCloudTelephony: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    blocksCloudTelephony: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.V1.ServicePlan}
 */
proto.V1.ServicePlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.V1.ServicePlan;
  return proto.V1.ServicePlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.V1.ServicePlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.V1.ServicePlan}
 */
proto.V1.ServicePlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setServicePlanType(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowsCloudTelephony(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlocksCloudTelephony(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.V1.ServicePlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.V1.ServicePlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.V1.ServicePlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.V1.ServicePlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getServicePlanType();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAllowsCloudTelephony();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getBlocksCloudTelephony();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.V1.ServicePlan.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.V1.ServicePlan} returns this
 */
proto.V1.ServicePlan.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.ServicePlan.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.ServicePlan} returns this
*/
proto.V1.ServicePlan.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.ServicePlan} returns this
 */
proto.V1.ServicePlan.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.ServicePlan.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue description = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.ServicePlan.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.ServicePlan} returns this
*/
proto.V1.ServicePlan.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.ServicePlan} returns this
 */
proto.V1.ServicePlan.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.ServicePlan.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue service_plan_type = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.V1.ServicePlan.prototype.getServicePlanType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.V1.ServicePlan} returns this
*/
proto.V1.ServicePlan.prototype.setServicePlanType = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.V1.ServicePlan} returns this
 */
proto.V1.ServicePlan.prototype.clearServicePlanType = function() {
  return this.setServicePlanType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.V1.ServicePlan.prototype.hasServicePlanType = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool allows_cloud_telephony = 5;
 * @return {boolean}
 */
proto.V1.ServicePlan.prototype.getAllowsCloudTelephony = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.V1.ServicePlan} returns this
 */
proto.V1.ServicePlan.prototype.setAllowsCloudTelephony = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool blocks_cloud_telephony = 6;
 * @return {boolean}
 */
proto.V1.ServicePlan.prototype.getBlocksCloudTelephony = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.V1.ServicePlan} returns this
 */
proto.V1.ServicePlan.prototype.setBlocksCloudTelephony = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


goog.object.extend(exports, proto.V1);
